<template>
  <div class="type-group">
    <div v-for="item in options" :key="item.type">
      <div
        class="type-content"
        @click="$emit('input', item.type)"
        :class="{ active: value === item.type }"
      >
        <div class="type-box" :class="itemClassNameFilter[item.type]">
          <div v-for="i in countFilter[item.type]" :key="i"></div>
        </div>
      </div>
      <p>{{ item.title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "GoodsOneLineTwo"
    },
    options: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    return {
      countFilter: Object.freeze({
        GoodsOneLineOne: 1,
        GoodsOneLineTwo: 2,
        GoodsOneLineThree: 3,
        GoodsSlider: 3
      }),
      itemClassNameFilter: Object.freeze({
        GoodsOneLineOne: "one-line-one",
        GoodsOneLineTwo: "one-line-two",
        GoodsOneLineThree: "one-line-three",
        GoodsSlider: "slider"
      })
    };
  }
};
</script>

<style lang="less" scoped>
.type-group {
  display: flex;
  flex-wrap: wrap;
  > div {
    > p {
      font-size: 12px;
      color: #333333;
      margin-top: 10px;
    }
  }
  .type-content {
    padding: 0;
    width: 54px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #eeeeee;
    border-radius: 2px;
    margin-right: 28px;
    cursor: pointer;

    .type-box {
      display: flex;
      div {
        width: 6px;
        height: 17px;
        position: relative;
        background: #c5c5c5;
        &:after {
          display: block;
          content: "";
          position: absolute;
          width: 6px;
          height: 1px;
          background: #c5c5c5;
          bottom: -3px;
          left: 0;
        }
      }
    }
    .one-line-one {
      > div {
        width: 20px;
        &:after {
          width: 20px;
        }
      }
    }

    .one-line-two {
      > div:first-child {
        margin-right: 2px;
      }
    }
    .one-line-three {
      > div:first-child,
      div:nth-child(2) {
        margin-right: 2px;
      }
    }
    .slider {
      > div:first-child,
      div:nth-child(2) {
        margin-right: 2px;
      }

      > div:last-child {
        width: 4px;
        &:after {
          width: 4px;
        }
      }
    }
  }
  .active {
    border: 1px solid #2154f4;
    .type-box {
      display: flex;
      div {
        background: #2154f4;
        &::after {
          background: #2154f4;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/marketingComponents/Seckill/components/TypeGroup.vue